<template>
	<div class="document page-break">
		<p style="text-align: right;">
			Приложение № {{ index }}
			<br>к Договору № {{ $root.contract.number }} от {{ $root.contract.date }}
		</p>
		<h4 class="h">Спецификация № {{ index }}</h4>
		<div class="spcf_table">
			<table class="table table-bordered" cellpadding="6">
				<tbody>
					<tr>
						<th>№ п.п.</th>
						<th>Наименование</th>
						<th>Единица измерения</th>
						<th>Количество лицензий</th>
						<th>Цена, руб.</th>
						<td><b>Сумма(без НДС)</b><br></td>
					</tr>
					<tr>
						<td>1</td>
						<td>Информационно-аналитическая система «Seldon 1.7». Право использования (простая (неисключительная) лицензия сроком на {{  license_period }} месяцев.

						</td>
						<td>шт.</td>
						<td>{{ license_count }}</td>
						<td>{{ license_price }}</td>
						<td>{{ license_total_sum }}</td>
					</tr>
					<tr>
						<td></td>
						<th colspan="4">Итого:</th>
						<th>{{ license_total_sum }}</th>
					</tr>
				</tbody>
			</table>
		</div>
		<div>
			<p>
				<b>Основные функциональные возможности:</b>
				<br><b>Программа для ЭВМ «Информационно-аналитическая система «Seldon 1.7»</b> – программный комплекс, позволяющий осуществлять мониторинг закупок государственного и коммерческого сектора, проводимых на территории Российской Федерации и странах ближнего зарубежья, способами, указанными ниже: 
				<ol>
					<li>Личный кабинет с возможность смены электронного адреса для получения рассылки и управления подпиской на новости техподдержки.</li>
					<li>Сервис рассылки информации по государственным , коммерческим и международным закупкам по заданным критериям, посредством электронной почты.</li>
				</ol>
				<b>Минимальные технические требования:</b>
				<br>Тип ЭВМ: IBM – совместимый компьютер, 2Гб ОЗУ, 300 Мб HDD, монитор с разрешением не менее 1280х1024, клавиатура, мышь.
				<br>ОС: Windows 7 и выше
				<br>Объём программы: 300 Мб
				<br>Интернет-соединение: стабильное интернет-соединение со скоростью не менее 1024Kbps.>
				<br><br><b>Способы использования:</b>
				<ol>
					<li>установка (запись) и хранение в памяти ЭВМ, запуск и эксплуатация в соответствии с назначением;</li>
					<li>обновление Программы в пределах одной версии (обновления выпускаются Лицензиатом, и предоставляются автоматически через Интернет при запуске Программы).</li>

				</ol>
				Лицензиат обязуется передать Сублицензиату в течение 5 (пяти) рабочих дней с момента внесения Сублицензиатом оплаты согласно п. 2.2 настоящего Договора, посредством сетей передачи данных (на электронную почту, указанную в разделе 7 договора): экземпляр Программы для ЭВМ «Информационно-аналитическая система «Seldon 1.7» в виде ссылки на дистрибутив Программы, а также средства идентификации (логин, пароль).
			</p>
		</div>
		<div>
			<table class="table table-bordered">
				<tbody>
					<tr>
						<th>
							<p>
								Лицензиат
								<br>{{ $root.licentiate.short_name }}
							</p>
						</th>
						<th>
							<p>
								Сублицензиат
								<br>{{ $root.sublicentiate.short_name }}
							</p>
						</th>
					</tr>
					<tr>
						<td>
							<p>{{ $root.licentiate.position }}</p>
							<br>_________________/{{ $root.licentiate.director_short }}/
								<br>М.П.
						</td>
						<td>
							<p>{{ $root.sublicentiate.position }}</p>
							<br>_________________/{{ $root.sublicentiate.director_short }}/
								<br>М.П.
						</td>
					</tr>
					<div class="sign_area">
						<div class="sign"></div>
					</div>
				</tbody>
			</table>
		</div>
	</div>
</template>
<script>
	export default {
		props: [
			'index',
			'license_period', 
			'license_count', 
			'license_price', 
			'license_user_count', 
			'license_total_sum'
		],
	}
</script>